import {Component, OnInit} from '@angular/core';
import {LookupService} from '../../common/service/lookup.service';
import {AuthenticatorService} from '../../common/service/authenticator.service';
import {PlanModelService} from '../../common/service/plan-model.service';
import {NgEventBus} from 'ng-event-bus';
import {Surveyor} from './surveyor.model';
import {SurveyingFirm} from './surveying-firm.model';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NlrTypeheadDirective} from '../../common/directive/nlr-typehead.directive';
import {debounceTime, distinctUntilChanged, map, Observable} from 'rxjs';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../common/pipe/nlr-permissions-disabled-pipe';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';
import {NlrFocusDirective} from '../../common/directive/nlr-focus.directive';

@Component({
    selector: 'nlr-surveyor-details',
    imports: [
        NgClass,
        FormsModule,
        NlrTypeheadDirective,
        NlrHasPermissionsPipe,
        NlrPermissionsDisabledPipe,
        NlrFormFieldHasErrorPipe,
        NlrFocusDirective
    ],
    templateUrl: './surveyor-details.component.html',
    styleUrl: './surveyor-details.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class SurveyorDetailsComponent implements OnInit {
    constructor(
        private lookupService: LookupService,
        private authenticatorService: AuthenticatorService,
        private planModelService: PlanModelService,
        private eventBus: NgEventBus
    ) {}

    get readonly() {
        return this.planModelService.readonly;
    }
    ngOnInit(): void {
        this.getAllocatedSurveyors();
        this.getEligibleSurveyors();
        this.getFirms();
    }

    title = 'Surveyor details';
    surveyors: Surveyor[];
    eligibleSurveyors: Surveyor[];
    firms: SurveyingFirm[];

    getModel() {
        return this.planModelService.getModel();
    }

    getSelectedSurveyor() {
        return this.getModel().surveyor ? this.getModel().surveyor.familyName + ' ' + this.getModel().surveyor.givenNames : '';
    }

    getAllocatedSurveyors() {
        const subs = this.lookupService.retrieveLookup<Surveyor[]>('/surveyors/allocated').subscribe({
            next: data => {
                this.surveyors = data;
                console.log('Surveyor load success ');
            },
            error: error => {
                console.error('Surveyor Load failed ' + error.message);
            }
        });
        this.eventBus.cast('nlr:busy', subs);
    }

    getEligibleSurveyors() {
        const subs = this.lookupService.retrieveLookup<Surveyor[]>('/surveyors/eligible').subscribe({
            next: data => {
                this.eligibleSurveyors = data;
                console.log('EligibleSurveyors load success ');
            },
            error: error => {
                console.error('EligibleSurveyors Load failed ' + error.message);
            }
        });
        this.eventBus.cast('nlr:busy', subs);
    }

    getFirms() {
        //replace to url nlrp/surveyors/surveyingFirms for json server
        const subs = this.lookupService.retrieveLookup<SurveyingFirm[]>('/surveyingFirms').subscribe({
            next: data => {
                this.firms = data;
                if (this.getModel().firm?.firmName === undefined) {
                    const usersFirm = this.firms.filter(row => row.firmNumber == this.authenticatorService.getUsersFirmNumber());
                    if (usersFirm.length > 0) {
                        this.getModel().firm = usersFirm[0];
                    }
                }
                console.log('SurveyingFirms load success ');
            },
            error: error => {
                console.error('SurveyingFirms Load failed ' + error.message);
            }
        });
        this.eventBus.cast('nlr:busy', subs);
    }

    surveyorChange() {
        this.surveyorIsSelected = false;
    }

    firmChange() {
        //$scope.planInformationForm['firm'].$setValidity('notSelected', false);
        // if (this.getModel().firm == "") {
        //     this.getModel().firm = undefined;
        //     // $scope.planInformationForm['firm'].$setValidity('notSelected', true);
        // }
    }

    surveyorSelected(event: string) {
        this.getModel().surveyor = this.surveyors.filter(s => s.familyName + ' ' + s.givenNames === event)[0];
        this.surveyorIsSelected = true;
    }

    surveyorIsSelected = true;

    firmSelected() {
        //$scope.planInformationForm['firm'].$setValidity('notSelected', true);
    }

    filterSurveyors(viewValue: string) {
        if (!viewValue) {
            return [];
        }
        return this.surveyors
            .filter(surveyor => {
                const surveyorFullName = surveyor.familyName + ' ' + surveyor.givenNames;
                return surveyorFullName.substring(0, viewValue.length).toLowerCase() == viewValue.toLowerCase();
            })
            .map(s => s.familyName + ' ' + s.givenNames);
    }

    filterSurveyorsByFullName: (text$: Observable<string>) => Observable<string[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => this.filterSurveyors(term))
        );

    filterFirmsByName(viewValue) {
        return this.firms.filter(firm => (firm.firmName + ' ' + firm.firmName).toLowerCase().startsWith(viewValue.toLowerCase()));
    }
}
